export default "__VITE_ASSET__DdS8F8HV__"